import { ModulusAPIResponse } from './external-api'

const UNAUTHORIZED_RESPONSES = ['unauthorized', 'invalid token']

export const getIsResponseUnauthorized = (
  response: ModulusAPIResponse<unknown> | null,
) => {
  const message = response?.message?.toLowerCase()
  if (!message) return false // Not really sure what case this would be

  const isUnauthorized = UNAUTHORIZED_RESPONSES.some((r) => message.includes(r))

  return isUnauthorized
}

export const getIsResponseIpMismatch = (data?: ModulusAPIResponse<unknown>) => {
  const isIpMismatchMessage = data?.message
    ?.toLowerCase()
    .includes('ip mismatch')
  return isIpMismatchMessage
}
